export var mixin =
    {
        computed: {
            allCoursesList() {
                return Object.values(this.$store.state.allCourses ?? {}) ?? []
            },
            allCourses() {
                return this.$store.state.allCourses ?? {}
            },
            allSelectedCourses(){
                return Object.values(this.coursesGroup.list) ?? []
            },
            coursesGroup() {
                return this.$store.state.courseGroups[this.$store.state.usingCourse]
            },
            courseOption() {
                return this.$store.state.timetableOptions
            },
            courseView() {
                return this.$store.state.viewState
            },
            user(){
                return this.$store.state.user
            },
            requestsProxy(){
                return "https://cors-anywhere.herokuapp.com/"
            }

        },
        methods: {
            updateCourse(course) {
                this.$store.commit('updateCourse', course)
            },
            coursesAdded(course){
                return this.allSelectedCourses.includes(course)
            },
            showCourseDetail(course) {
                console.log("Clicked course:", course.cname)
                this.courseOption.courseDetail.showDetail = true
                this.courseOption.courseDetail.showCourse = course
            }
        }
    }
